import { getErrorCode } from '@onefootprint/fetch-hosted';

/**
 * Returns true when the error is E118 (session expired).
 * Use in mutation catch blocks to show the session expired screen.
 */
export const isSessionExpired = (error: unknown): boolean => {
  return getErrorCode(error) === 'E118';
};
